import React, { useState } from 'react';
import { usePremiumOpportunities } from '../hooks/usePremiumOpportunities';
import OpportunityCard from '../components/OpportunityCard';

const PremiumOpportunitiesPage = () => {
  const [activeFilter, setActiveFilter] = useState('edge');
  const {
    realValueBets,
    nearValueBets,
    pricedByMarket,
    summary,
    message,
    loading,
    error,
    refreshing
  } = usePremiumOpportunities(activeFilter);
  const noValueData = !realValueBets.length && !nearValueBets.length && !pricedByMarket.length;

  const filters = [
    { id: 'edge', label: 'En Guclu Edge' },
    { id: 'time', label: 'Baslamasi Yakin' },
    { id: 'confidence', label: 'Guven Yuksek' },
    { id: 'ust_kg', label: 'Ust/KG' },
    { id: 'ms', label: 'MS' },
    { id: 'live_watch', label: 'Canli Takip' }
  ];

  if (loading || refreshing) return <div className="loading">Bugunun analizleri hazirlaniyor. Lutfen birkac dakika sonra tekrar kontrol edin.</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="page analysis-page">
      <section className="hero-panel compact premium-coupon-hero">
        <div className="hero-copy">
          <span className="hero-badge premium-hero-badge">
            <img src="/premium-crown.svg" alt="Premium tac" />
            <span>VALUE BET</span>
          </span>
          <h1 className="live-hero-title">GERCEK EDGE, YAKIN VALUE VE PIYASA FIYATLAMASI</h1>
          <p>
            Bugun {summary.realCount} gercek value bet, {summary.nearCount} yakin value, {summary.pricedCount} piyasa tarafindan fiyatlanmis guclu model yonu bulundu.
          </p>
        </div>
      </section>

      <section className="content-panel">
        <div className="filter-group">
          {filters.map((filter) => (
            <button
              key={filter.id}
              type="button"
              className={`filter-chip ${activeFilter === filter.id ? 'active' : ''}`}
              onClick={() => setActiveFilter(filter.id)}
            >
              {filter.label}
            </button>
          ))}
        </div>
      </section>

      <section className="content-panel">
        <div className="analysis-header">
          <span>GERCEK VALUE BETLER</span>
          <span className="confidence high">{realValueBets.length} mac</span>
        </div>
        {realValueBets.length === 0 ? (
          <>
            <p className="analysis-summary">{noValueData && message ? message : 'Su an gercek pozitif edge tasiyan value bet bulunmuyor.'}</p>
            {!noValueData ? <p className="analysis-summary">Ancak modelin guclu gordugu ve canlida takip edilebilecek maclar asagida listelenmistir.</p> : null}
          </>
        ) : (
          <div className="analysis-grid premium-opportunity-grid">
            {realValueBets.map((item) => (
              <OpportunityCard key={item.id} item={item} variant="real" />
            ))}
          </div>
        )}
      </section>

      <section className="content-panel">
        <div className="analysis-header">
          <span>YAKIN VALUE TAKIBI</span>
          <span className="confidence medium">{nearValueBets.length} mac</span>
        </div>
        {nearValueBets.length ? (
          <div className="analysis-grid premium-opportunity-grid">
            {nearValueBets.map((item) => (
              <OpportunityCard key={item.id} item={item} variant="near" />
            ))}
          </div>
        ) : (
          <p className="analysis-summary">{noValueData && message ? message : 'Canlida takip edilebilecek yakin value adayi su an bulunmuyor.'}</p>
        )}
      </section>

      <section className="content-panel">
        <div className="analysis-header">
          <span>PIYASA FIYATLAMIS</span>
          <span className="confidence low">{pricedByMarket.length} mac</span>
        </div>
        {pricedByMarket.length ? (
          <div className="analysis-grid premium-opportunity-grid">
            {pricedByMarket.map((item) => (
              <OpportunityCard key={item.id} item={item} variant="priced" />
            ))}
          </div>
        ) : (
          <p className="analysis-summary">{noValueData && message ? message : 'Piyasanin zaten fiyatladigi belirgin model yonu su an listelenmedi.'}</p>
        )}
      </section>
    </div>
  );
};

export default PremiumOpportunitiesPage;
